import { Component, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { RegisterComponent } from 'src/app/common/extensions/decorator';
import { ProcedureCreditedService } from '../../services/procedure-credited.service';

@RegisterComponent('TestPendingApprovalReportsComponent')
@Component({
  selector: 'app-test-pending-approval-reports',
  templateUrl: './test-pending-approval-reports.component.html',
  styleUrls: ['./test-pending-approval-reports.component.scss']
})
export class TestPendingApprovalReportsComponent extends BaseComponent {

  loading = false;

  constructor(
    protected override injector: Injector,
    private procedureCreditedService: ProcedureCreditedService,
    private dialogRef: MatDialogRef<TestPendingApprovalReportsComponent>
  ) {
    super(injector);
  }

  /**
   * Invokes the pending-approval report PATCH endpoint and closes the dialog after a successful request.
   */
  generateReports() {
    this.loading = true;
    this.procedureCreditedService.generatePendingApprovalsEmails().pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: () => {
        this.alert.success('Pending approval procedure reports were generated.');
        this.dialogRef.close(true);
      },
      error: () => this.alert.defaultError()
    });
  }

  /** Closes the report test dialog without starting the email job. */
  cancel() {
    this.dialogRef.close();
  }
}
